<template>
<div class="card card-dashboard-twenty" style="height:100%" v-loading='loading' v-if='pensions.length != 0'>
    <div class="card-header">
        <div style="
        display: flex;
        align-items: center;
        justify-content: space-between;">
            <h6 class="card-title" style="text-transform:none;margin-bottom:5px">Pensions</h6>
            <small>{{fy}}</small>
        </div>
        <p class="mg-b-0">
            <small>
                <router-link :to='{path:$route.params.fund_code+"/pensions/",query:{name:$route.query.name,page:"Pensions"}}'>
                    View Full Pension Details
                </router-link>
            </small></p>
    </div><!-- card-header -->
    <div class="table-responsive mg-t-15 mg-b-15">
        <table class="table table-striped table-talk-time">
            <tbody>
                <tr v-for='(pension,index) in pensions' :key='pension.id'>
                    <td style="width: 40%;">{{isSample?'Mr Mike Sample '+(index+1):pension.trustee}} <br>
                        <span style='font-size:12px;color:gray'>{{pension.account}}</span>
                    </td>
                    <td v-show='pension.paid > pension.min'>
                        <div class="expansion-value" >
                            <strong style="color:#1c273c;font-size:12px">{{currentformats.AUformat(pension.min)}}</strong>
                            <strong>{{currentformats.AUformat(pension.paid)}}</strong>
                        </div>
                        <div class="progress" style="height:8px;background-color:rgba(51, 102, 255, 0.7)">
                            <div class="progress-bar bg-primary" :style="{'width':pension.paid!=0?((pension.min/pension.paid)*100).toFixed(2)+'px':0}" role="progressbar" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <div class="expansion-label">
                            <span>Minimum</span>
                            <span>Pension paid year to date</span>
                        </div>
                    </td>
                    <td v-show='pension.paid < pension.min || pension.paid === pension.min'>
                        <div class="expansion-value">
                            <strong>{{currentformats.AUformat(pension.paid)}}</strong>
                            <strong>{{currentformats.AUformat(pension.min)}}</strong>
                        </div>
                        <div class="progress" style="height:8px">
                            <div class="progress-bar bg-primary" :style="{'width':pension.min!=0?((pension.paid/pension.min)*100).toFixed(2)+'px':0}" role="progressbar" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <div class="expansion-label">
                            <span>Pension paid year to date</span>
                            <span>Minimum</span>
                        </div>
                    </td>
                    
                </tr>
            </tbody>
        </table>
    </div><!-- table-responsive -->
      <DisclaimerV2 button-style="font-size:12px;margin-left:12px">
        <div style="font-size:12px;max-width:600px">
          The minimum pension amounts displayed are estimates if the most recent 30 June tax return has not been lodged. Final figures should be verified once year-end accounts are finalised.
        </div>
      </DisclaimerV2>
</div><!-- card -->
</template>
<script>
import dateformats from '../../../utils/dateformats'
import currentformats from '../../../utils/currentformats'
export default {
    name:'fundpension',
    components: { 
        DisclaimerV2: () => import('@/views/adviserpanel/elements/DisclaimerV2.vue'),
    },
    data(){
        return{
            isSample:false,
            fy: dateformats.getFinancialYear(),
            currentformats:currentformats,
            pensions:[], 
            loading:true
        }
    },
    created(){
        this.getPension();
    },
    methods:{
        getPension: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            this.isSample=userdetail['sample'];
            this.$api.funddashboard_api.fundPension(this.$route.params.fund_code).then(response =>{
                //note that the data for prev year and this year is reversed
                this.pensions = response.data['pension_list']
                this.loading=false
            });
        
        },
    }
}
</script>
